var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.21 17.5201C1.11376 17.5211 1.01827 17.503 0.929032 17.467C0.83979 17.431 0.758555 17.3776 0.690003 17.3101C0.611406 17.2324 0.55093 17.1384 0.512899 17.0347C0.474868 16.931 0.46022 16.8201 0.470003 16.7101L0.780003 12.8701C0.793296 12.6917 0.871579 12.5245 1 12.4001L12.06 1.34007C12.6763 0.762984 13.4961 0.453728 14.34 0.480071C15.1784 0.486576 15.9828 0.811935 16.59 1.39007C17.1724 1.98807 17.5073 2.78403 17.5277 3.61849C17.5481 4.45296 17.2525 5.26433 16.7 5.89007L5.63 17.0001C5.50611 17.1235 5.34387 17.2011 5.17 17.2201L1.28 17.5701L1.21 17.5201ZM2.21 13.2601L2 16.0001L4.74 15.7501L15.64 4.83007C15.8525 4.57855 15.9884 4.2713 16.0314 3.94485C16.0745 3.61839 16.0229 3.28643 15.8828 2.98842C15.7428 2.6904 15.5201 2.43886 15.2413 2.26366C14.9625 2.08846 14.6393 1.99697 14.31 2.00007C14.0936 1.98633 13.8766 2.01645 13.6721 2.08862C13.4676 2.16079 13.2798 2.27353 13.12 2.42007L2.21 13.2601Z",
    fill: "#474747"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.7c2b8e19d65a15def0d8c829666d05e1.svg";
export { ForwardRef as ReactComponent };